module.exports = __webpack_public_path__ + "img/Portfolio.95087855.svg";